import { AlertCircle, MessageSquareOff } from "lucide-react"

import { Button } from "@f2e/ui/components/base"

export interface HistorySelectionStateProps {
  kind: "unsupported" | "error"
  title: string
  description: string
  actionLabel: string
  onAction: () => void
}

const HistorySelectionState = ({
  kind,
  title,
  description,
  actionLabel,
  onAction,
}: HistorySelectionStateProps) => {
  const Icon = kind === "unsupported" ? MessageSquareOff : AlertCircle

  return (
    <div className="flex min-h-[32rem] items-center justify-center rounded-xl border bg-background px-6 py-12">
      <div
        className="flex max-w-md flex-col items-center text-center"
        role={kind === "error" ? "alert" : "status"}
      >
        <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-muted">
          <Icon
            className={
              kind === "error"
                ? "h-5 w-5 text-destructive"
                : "h-5 w-5 text-muted-foreground"
            }
            aria-hidden="true"
          />
        </div>
        <h2 className="text-lg font-semibold text-foreground">{title}</h2>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">
          {description}
        </p>
        <Button className="mt-5" variant="outline" onClick={onAction}>
          {actionLabel}
        </Button>
      </div>
    </div>
  )
}

export default HistorySelectionState
